module.exports = __webpack_public_path__ + "static/media/f37ginger-bold-webfont.148909f0.woff";